import request from '@/utils/request'

// 查询企业微信-群聊成员列表
export function listChatMember(query) {
    return request({
        url: '/wxCp/chatMember/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信-群聊成员详细
export function getChatMember(id) {
    return request({
        url: '/wxCp/chatMember/' + id,
        method: 'get'
    })
}

// 新增企业微信-群聊成员
export function addChatMember(data) {
    return request({
        url: '/wxCp/chatMember',
        method: 'post',
        data: data
    })
}

// 修改企业微信-群聊成员
export function updateChatMember(data) {
    return request({
        url: '/wxCp/chatMember/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信-群聊成员
export function delChatMember(id) {
    return request({
        url: '/wxCp/chatMember/delete/' + id,
        method: 'post'
    })
}
